<template>
  <div class="library-page">
    <!-- 顶部导航 -->
    <!-- <AppHeader /> -->

     <!-- 1. Banner 区域 (深色) -->
    <section class="lib-banner">
      <div class="banner-overlay"></div>
      <div class="container">
        <div class="banner-content">
          <h1>AI数字人<br>图书检索系统</h1>
          <p class="subtitle">找书更快，阅读更好</p>
          <button class="btn-primary" @click="contactUs">
            合作咨询 <span class="divider">|</span> 020-82038386
          </button>
        </div>
        <!-- 移除右侧模拟设备，让背景图片中的设备透出来 -->
      </div>
    </section>

    <!-- 2. 核心功能 (白色背景) -->
     <!-- 2. 核心功能 (白色背景) -->
    <section class="lib-features">
      <div class="container">
        <div class="section-title">
          <h2>核心功能</h2>
        </div>
        <div class="features-grid">
          <div class="feature-card" v-for="item in features" :key="item.id">
            <h4>{{ item.title }}</h4>
            <div class="icon-box">
              <img src="../assets/images/headphone-icon.png" alt="图标" class="feature-icon">
            </div>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 3. 软硬件一体化终端 (浅灰背景) -->
    <section class="lib-terminal">
      <div class="container">
        <div class="section-title">
          <h2>软硬件一体化终端</h2>
          <p class="subtitle">专为智慧图书馆打造的智能终端设备</p>
        </div>
        <div class="terminal-layout">
          <div class="terminal-features">
            <div class="tf-item" v-for="(item, index) in terminalFeatures" :key="index">
              <div class="check-icon">
                <img src="../assets/images/check-icon.png" alt="勾选" class="check-img">
              </div>
              <div>
                <strong>{{ item.title }}</strong>
                <p>{{ item.desc }}</p>
              </div>
            </div>
          </div>
          <div class="terminal-device">
            <div class="image-wrapper">
              <img src="../assets/images/class-card-device.png" alt="智能终端设备" class="device-img">
            </div>
          </div>
        </div>
      </div>
    </section>

<!-- 4. 产品优势 (极淡背景) -->
<section class="lib-advantages">
  <div class="container">
    <div class="section-title">
      <h2>产品优势</h2>
    </div>
    <div class="adv-grid">
      <div class="adv-item" v-for="adv in advantages" :key="adv.id">
        <h4>{{ adv.title }}</h4>
        <p>{{ adv.desc }}</p>
      </div>
    </div>
  </div>
</section>

<!-- 5. 应用场景 (白色背景) -->
<section class="lib-scenarios">
  <div class="container">
    <div class="section-title">
      <h2>应用场景</h2>
    </div>
    <div class="scenarios-grid">
      <div class="scenario-card" v-for="scene in scenarios" :key="scene.id">
        <div class="scenario-img-box">
          <!-- 引入场景图片 -->
          <img :src="scene.img" :alt="scene.title" class="scene-img">
        </div>
        <div class="scenario-info">
          <h4>{{ scene.title }}</h4>
          <p>{{ scene.desc }}</p>
        </div>
      </div>
    </div>
  </div>
</section>

    <!-- 底部 -->
    <AppFooter />

    <!-- 悬浮返回按钮 -->
    <button class="back-btn" @click="goBack">← 返回首页</button>
  </div>
</template>

<script>
// import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'

export default {
  name: 'AILibrarySearch',
  components: {  AppFooter },
  data() {
    return {
       features: [
        {
          id: 1,
          title: 'AI数字人引导',
          desc: '拟人化AI数字人形象，亲切自然的交互体验，引导用户轻松完成检索。'
        },
        {
          id: 2,
          title: '语音检索',
          desc: '支持语音输入，自然语言理解，快速准确匹配书籍资源。'
        },
        {
          id: 3,
          title: '智能书籍推荐',
          desc: '基于用户兴趣与借阅数据，智能推荐相关书籍，发现更多好书。'
        },
        {
          id: 4,
          title: '多模态交互',
          desc: '支持语音、触控交互方式，满足不同用户使用习惯。'
        }
      ],
      terminalFeatures: [
        { title: '高清触控屏，响应灵敏，显示清晰' },
        { title: '内置高性能处理器，运行流畅稳定' },
        { title: '集成麦克风阵列，远场语音识别更精准' },
        { title: '模块化设计，安装维护便捷' },
        { title: '支持定制化开发，满足个性化需求' }
      ],
     advantages: [
      { id: 1, title: 'AI赋能', desc: '先进的人工智能技术，持续学习与优化，越用越懂你。' },
      { id: 2, title: '精准高效', desc: '毫秒级检索响应，精准定位，节省时间提升效率。' },
      { id: 3, title: '资源整合', desc: '打通馆内外资源，一站式检索，全面获取知识。' },
      { id: 4, title: '易用友好', desc: '界面简洁，操作便捷，老少皆宜，无障碍使用。' },
      { id: 5, title: '安全可靠', desc: '数据安全保障，系统稳定可靠，7×24小时服务。' }
    ],
    scenarios: [
      { 
        id: 1, 
        title: '中小学图书馆', 
        desc: '培养阅读兴趣，助力学生自主学习。',
        img: require('@/assets/images/scene-school.png') // 替换为真实路径
      },
      { 
        id: 2, 
        title: '高校图书馆', 
        desc: '提升服务效率，优化读者体验，打造智慧化学习空间。',
        img: require('@/assets/images/scene-university.png')
      },
      { 
        id: 3, 
        title: '公共图书馆', 
        desc: '智能化服务升级，让知识触手可及。',
        img: require('@/assets/images/scene-public.png')
      },
      { 
        id: 4, 
        title: '企业/机构图书馆', 
        desc: '高效知识管理，赋能组织学习与创新。',
        img: require('@/assets/images/scene-enterprise.png')
      }]
    }
  },
  methods: {
    goBack() {
      this.$emit('back')
    },
    contactUs() {
      alert('联系电话：020-82038386')
    }
  }
}
</script>

<style scoped>
.container { 
  max-width: 1400px; 
  margin: 0 auto; 
  padding: 0 20px;
  position: relative;
  z-index: 2;
}

/* 1. Banner (深色背景图) */
.lib-banner {
  position: relative;
  /* 引入背景图片 - 包含左侧走廊和右侧设备 */
  background-image: url('../assets/images/class-card-banner-bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: #fff;
  padding: 120px 0;
  min-height: 600px;
  display: flex;
  align-items: center;
}

/* 渐变遮罩：左侧深色保护文字，右侧透明显示设备 */
.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* 从左到右：深色渐变到透明 */
  background: linear-gradient(to right, 
    rgba(15, 23, 42, 0.95) 0%, 
    rgba(15, 23, 42, 0.9) 45%, 
    rgba(15, 23, 42, 0.4) 75%,
    transparent 100%);
}

.lib-banner .container { 
  display: flex; 
  align-items: center; 
  justify-content: flex-start; /* 内容靠左 */
  width: 100%;
}

.banner-content { 
  flex: 1;
  max-width: 600px; /* 限制文字区域宽度 */
}

.banner-content h1 { 
  font-size: 56px; 
  line-height: 1.2; 
  margin-bottom: 20px; 
  font-weight: bold;
}

.subtitle { 
  font-size: 22px; 
  color: rgba(255, 255, 255, 0.9); 
  margin-bottom: 40px; 
  font-weight: 500;
}

.btn-primary { 
  background: #10b1f2; 
  color: #fff; 
  border: none; 
  padding: 14px 32px;
  border-radius: 24px; 
  font-size: 16px; 
  cursor: pointer; 
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
}

.btn-primary:hover { 
  background: #1557b0;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(26, 115, 232, 0.4);
}

.divider {
  opacity: 0.6;
  margin: 0 4px;
}

/* 响应式 */
@media (max-width: 992px) {
  .banner-content h1 {
    font-size: 40px;
  }
  
  .subtitle {
    font-size: 18px;
  }
  
  .banner-overlay {
    background: rgba(15, 23, 42, 0.85); /* 手机端全遮罩 */
  }
}

@media (max-width: 768px) {
  .banner-content h1 {
    font-size: 32px;
  }
  
  .subtitle {
    font-size: 16px;
  }
}
/* 2. Features
/* 2. Features  */
.lib-features { 
  padding: 80px 0; 
  background: #f8fafc; 
}

.section-title { 
  text-align: center; 
  margin-bottom: 50px; 
}

.section-title h2 { 
  font-size: 32px; 
  color: #1e293b; 
  margin-bottom: 10px;
  font-weight: bold;
}
.section-title .subtitle {
  font-size: 16px;
  color: #475569; /* 副标题灰色 */
  font-weight: 600;
  margin: 0;
}

.features-grid { 
  display: grid; 
  grid-template-columns: repeat(4, 1fr); 
  gap: 24px; 
}

.feature-card {
  background: #fff; 
  padding: 35px 25px; 
  border-radius: 12px;
  text-align: center; 
  border: 1px solid #f1f5f9; 
  transition: all 0.3s;
}

.feature-card:hover { 
  transform: translateY(-5px); 
  box-shadow: 0 10px 30px rgba(0,0,0,0.08); 
}

.feature-card h4 { 
  margin-bottom: 10px; 
  color: #1e293b; 
  font-size: 16px;
  font-weight: 600;
  min-height: 44px; /* 确保标题高度一致 */
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-box {
  width: 56px; 
  height: 56px; 
  margin: 0 auto 20px; 
  display: flex; 
  align-items: center; 
  justify-content: center; 
}

.feature-icon {
  width: 56px;
  height: 56px;
  object-fit: contain;
}

.feature-card p { 
  font-size: 13px; 
  color: #64748b; 
  line-height: 1.6;
  margin: 0;
}

/* 3. Terminal (浅灰) */
.lib-terminal { 
  padding: 80px 0; 
  background: #ffffff; 
}

.terminal-layout { 
  display: flex; 
  align-items: flex-start; 
  gap: 80px; 
  max-width: 1400px;
  margin: 0 auto;
}

.terminal-features { 
  flex: 1; 
  max-width: 500px;
  margin-top: 60px;
}

.tf-item {
  display: flex; 
  align-items: flex-start; 
  gap: 16px; 
  margin-bottom: 30px;
}

.check-icon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  margin-top: 3px;
}

.check-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.tf-item strong {
  display: block;
  color: #1e293b;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
}

.tf-item p {
  color: #64748b;
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
}

.terminal-device { 
  flex: 1; 
  display: flex; 
  justify-content: center;
}

.image-wrapper {
  position: relative;
  /* border: 1px dashed #cbd5e1; */
  /* border-radius: 8px; */
  /* padding: 30px; */
  /* background: #fff; */
}

.device-img {
  max-width: 100%;
  height: auto;
  display: block;
  border-radius: 4px;
}

/* 响应式 */
@media (max-width: 992px) {
  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .terminal-layout {
    flex-direction: column;
    gap: 50px;
  }
}

@media (max-width: 768px) {
  .features-grid {
    grid-template-columns: 1fr;
  }
}


/* 4. Advantages (极淡蓝灰背景) */
.lib-advantages { 
  padding: 80px 0; 
  background: #f8fafc; /* 极淡的背景色 */
}

.adv-grid { 
  display: grid; 
  grid-template-columns: repeat(5, 1fr); 
  gap: 30px; 
}

.adv-item {
  text-align: center;
  padding: 10px;
}

.adv-item h4 { 
  margin-bottom: 12px; 
  color: #1e293b; 
  font-size: 18px; 
  font-weight: bold;
}

.adv-item p { 
  font-size: 13px; 
  color: #64748b; 
  line-height: 1.6; 
}

/* 5. Scenarios (白色背景) */
/* 5. Scenarios (白色背景) */
.lib-scenarios { 
  padding: 80px 0; 
  background: #fff; 
}

/* .section-title {
  text-align: center;
  margin-bottom: 50px;
}

.section-title h2 {
  font-size: 32px;
  color: #1e293b;
  font-weight: bold;
  margin: 0;
} */

.scenarios-grid { 
  display: grid; 
  grid-template-columns: repeat(4, 1fr); 
  gap: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.scenario-card {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease;
}

.scenario-card:hover {
  transform: translateY(-5px);
}

/* 图片区域 */
.scenario-img-box {
  height: 200px;
  overflow: hidden;
  background: #f1f5f9;
}

.scene-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}

.scenario-card:hover .scene-img {
  transform: scale(1.05);
}

/* 文字信息区域 (浅蓝色背景) */
.scenario-info {
  background: #f0f7ff; /* 浅蓝色背景 */
  padding: 25px 20px;
  text-align: center;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.scenario-info h4 { 
  margin: 0 0 12px 0; 
  color: #1e293b; 
  font-size: 18px; 
  font-weight: 600;
  line-height: 1.3;
}

.scenario-info p { 
  font-size: 14px; 
  color: #64748b; 
  line-height: 1.6; 
  margin: 0;
}

/* 响应式设计 */
@media (max-width: 1400px) {
  .scenarios-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .lib-scenarios {
    padding: 60px 0;
  }
  
  .section-title h2 {
    font-size: 28px;
  }
  
  .scenarios-grid {
    grid-template-columns: 1fr;
    max-width: 500px;
  }
  
  .scenario-img-box {
    height: 220px;
  }
  
  .scenario-info h4 {
    font-size: 17px;
  }
  
  .scenario-info p {
    font-size: 13px;
  }
}
/* 返回按钮 */
.back-btn {
  position: fixed; bottom: 30px; right: 30px;
  background: #1e293b; color: #fff; border: none;
  padding: 15px 30px; border-radius: 30px;
  cursor: pointer; box-shadow: 0 5px 20px rgba(0,0,0,0.3);
  z-index: 1000; font-size: 16px;
}
.back-btn:hover { background: #334155; }
</style>